// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"769":"a1f6dc10","895":"8f847095","4168":"059d1ca5","5230":"059d1ca5"}[chunkId] + ".chunk.css";
};